// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'plug-solid';

export const Component = () => (
  <>
    <path
      fill='currentColor'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M9 12.96a4.44 4.44 0 0 1-4.464-4.464V5.04c0-.648.504-1.152 1.152-1.152h6.768c.648 0 1.152.504 1.152 1.152v3.384C13.536 10.944 11.52 12.96 9 12.96z'
    />
    <path
      fill='currentColor'
      d='M6.768 12.312v1.728c0 .648.504 1.152 1.152 1.152h2.232c.648 0 1.152-.504 1.152-1.152v-1.728'
    />
    <path
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M6.768 12.312v1.728c0 .648.504 1.152 1.152 1.152h2.232c.648 0 1.152-.504 1.152-1.152v-1.728M6.768 3.96V.576m4.464 3.384V.576M9 15.192v2.232'
    />
  </>
);

export const viewBox = '0 0 18 18';
